export const tomato = {
  1: { value: { base: '{colors.tomato.light.1}', _dark: '{colors.tomato.dark.1}' } },
  2: { value: { base: '{colors.tomato.light.2}', _dark: '{colors.tomato.dark.2}' } },
  3: { value: { base: '{colors.tomato.light.3}', _dark: '{colors.tomato.dark.3}' } },
  4: { value: { base: '{colors.tomato.light.4}', _dark: '{colors.tomato.dark.4}' } },
  5: { value: { base: '{colors.tomato.light.5}', _dark: '{colors.tomato.dark.5}' } },
  6: { value: { base: '{colors.tomato.light.6}', _dark: '{colors.tomato.dark.6}' } },
  7: { value: { base: '{colors.tomato.light.7}', _dark: '{colors.tomato.dark.7}' } },
  8: { value: { base: '{colors.tomato.light.8}', _dark: '{colors.tomato.dark.8}' } },
  9: { value: { base: '{colors.tomato.light.9}', _dark: '{colors.tomato.dark.9}' } },
  10: { value: { base: '{colors.tomato.light.10}', _dark: '{colors.tomato.dark.10}' } },
  11: { value: { base: '{colors.tomato.light.11}', _dark: '{colors.tomato.dark.11}' } },
  12: { value: { base: '{colors.tomato.light.12}', _dark: '{colors.tomato.dark.12}' } },
  a1: { value: { base: '{colors.tomato.light.a1}', _dark: '{colors.tomato.dark.a1}' } },
  a2: { value: { base: '{colors.tomato.light.a2}', _dark: '{colors.tomato.dark.a2}' } },
  a3: { value: { base: '{colors.tomato.light.a3}', _dark: '{colors.tomato.dark.a3}' } },
  a4: { value: { base: '{colors.tomato.light.a4}', _dark: '{colors.tomato.dark.a4}' } },
  a5: { value: { base: '{colors.tomato.light.a5}', _dark: '{colors.tomato.dark.a5}' } },
  a6: { value: { base: '{colors.tomato.light.a6}', _dark: '{colors.tomato.dark.a6}' } },
  a7: { value: { base: '{colors.tomato.light.a7}', _dark: '{colors.tomato.dark.a7}' } },
  a8: { value: { base: '{colors.tomato.light.a8}', _dark: '{colors.tomato.dark.a8}' } },
  a9: { value: { base: '{colors.tomato.light.a9}', _dark: '{colors.tomato.dark.a9}' } },
  a10: { value: { base: '{colors.tomato.light.a10}', _dark: '{colors.tomato.dark.a10}' } },
  a11: { value: { base: '{colors.tomato.light.a11}', _dark: '{colors.tomato.dark.a11}' } },
  a12: { value: { base: '{colors.tomato.light.a12}', _dark: '{colors.tomato.dark.a12}' } },
}
